import { render, staticRenderFns } from "./simList.vue?vue&type=template&id=2958607d&"
import script from "./simList.vue?vue&type=script&lang=js&"
export * from "./simList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports